interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Outline link/access glyph used on the "people with access" permission banner. */
const FigmaAccessIcon = ({ width = 20, height = 20, color = '#8B5CF6' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.5 14.1667H5.83333C4.72826 14.1667 3.66846 13.7277 2.88706 12.9463C2.10565 12.1649 1.66667 11.1051 1.66667 10C1.66667 8.89493 2.10565 7.83512 2.88706 7.05372C3.66846 6.27232 4.72826 5.83333 5.83333 5.83333H7.5'
      stroke={color}
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.5 5.83333H14.1667C15.2717 5.83333 16.3315 6.27232 17.1129 7.05372C17.8943 7.83512 18.3333 8.89493 18.3333 10C18.3333 11.1051 17.8943 12.1649 17.1129 12.9463C16.3315 13.7277 15.2717 14.1667 14.1667 14.1667H12.5'
      stroke={color}
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.66666 10H13.3333'
      stroke={color}
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default FigmaAccessIcon;
